export default "__VITE_ASSET__CmlJ1vpC__"